import { SVGProps } from 'react';

const Direction = ({
    width = 18,
    height = 18,
    fill1 = '#2A2A2A',
    fill2 = '#00AEC7',
    ...otherProps
}: any) => (
    <svg width="18" {...otherProps} height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 17.999V9.63652C10.5 9.23652 10.425 8.85527 10.275 8.49277C10.125 8.13027 9.9125 7.81152 9.6375 7.53652L2.1 -0.000976562L0 2.09902L7.5 9.59902V17.999H10.5Z" fill={fill1} fill-opacity="0.7" />
        <path d="M7.50024 17.999V9.63652C7.50024 9.23652 7.57524 8.85527 7.72524 8.49277C7.87524 8.13027 8.08774 7.81152 8.36274 7.53652L12.9002 2.99902H9.52524V-0.000976562H18.0002V8.47402H15.0002V5.09902L10.5002 9.59902V17.999H7.50024Z" fill={fill2} />
    </svg>
);

export default Direction;




